module.exports = __webpack_public_path__ + "static/media/subpage_back.5e18a747.svg";